import React from 'react'
import { ResultDisplayProps } from '../../common'
import { CUSTOM_PRESET_MAPPING } from '../../../CustomPresets/CustomPresetMapping'
import { ErrorBoundary } from 'react-error-boundary'

export const CollapsedResultDisplay: React.FC<ResultDisplayProps> = (props) => {
  const {
    aiFeature: { preset: { id: presetId } = {} },
  } = props

  if (!presetId) {
    return null
  }

  const CollapsedResultDisplayElement = CUSTOM_PRESET_MAPPING[presetId]?.collapsedDisplay

  if (CollapsedResultDisplayElement) {
    return (
      <div className='d-flex flex-column w-100'>
        <ErrorBoundary fallback={null}>
          <CollapsedResultDisplayElement {...props} />
        </ErrorBoundary>
      </div>
    )
  }

  return null
}
